
import { useAuth } from "@/hooks/auth/useAuth";
import { AuthGuard } from "./AuthGuard";

interface AdminAuthGuardProps {
  children: React.ReactNode;
}

export const AdminAuthGuard = ({ children }: AdminAuthGuardProps) => {
  return (
    <AuthGuard adminOnly={true}>
      {children}
    </AuthGuard>
  );
};
